import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useState, useEffect } from 'react';

export const AzureADUserLogin = (props) => {
    var preloader = document.getElementById("preloader");
    preloader.classList.add("hidden");
    const [userInfo, setUserInfo] = useState(null);
    const history = useHistory();
    useEffect(() => {
        if (sessionStorage.getItem('UserInfo')) {
            setUserInfo(localStorage.getItem('login_status'))
            sessionStorage.setItem('azureInit', 'true')
            $('#globalLoader').hide();
            history.push('/home');
        }
    }, []);

    
    return (
        <>          
            <h5>
                <div> Loading...</div>
            </h5>
            <br />
            <br />
            {props.children}
        </>
    );
};
export default connect()(AzureADUserLogin);
